module.exports = __webpack_public_path__ + "media/icons/phone--white-e7a708b4.svg";